export default (e: any) => ({
	message:
		e?.networkError?.result?.errors?.[0]?.extensions ||
		e?.graphQLErrors?.[0]?.message,
	code: e?.graphQLErrors?.[0]?.code as undefined | number | null,
})
